import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@mui/material/Tooltip'
import { DownloadButton } from './styles'
import 'material-icons/iconfont/outlined.css'

const DownloadPdfButton = ({ onClick }) => (
  <Tooltip
    title={<span style={{ color: 'white', fontWeight: 600 }}>Exportar PDF</span>}
    arrow
    placement="top"
    componentsProps={{
      tooltip: {
        sx: {
          backgroundColor: '#39C98F',
        },
      },
      arrow: {
        sx: {
          color: '#39C98F',
        },
      },
    }}
  >
    <DownloadButton onClick={onClick}>
      <span className="material-icons-outlined">file_download</span>
    </DownloadButton>
  </Tooltip>
)

DownloadPdfButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default DownloadPdfButton
